import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { showNotification } from '@/utils/notificationUtils';

export type requestDTO = {

  stateId?: number | string;
    newCity:any

};

export const addCity = ({ stateId, newCity}: requestDTO) => {
        return axios.post(`/superadmin/add-new-city`, {stateId, newCity});
};

type UseAddUserOptions = {
  config?: MutationConfig<typeof addCity>;
};

export const useAddCityMutation = ({ config }: UseAddUserOptions = {}) => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'City added successfully',
      });
    },
    ...config,
    mutationFn: addCity,
  });
};


export type requestDTO1 = {

  stateId?: number | string;
    stateName:any

};

export const updateState = ({ stateId, stateName}: requestDTO1) => {
        return axios.post(`/superadmin/update-state`, {stateId, stateName});
};

type UseAddUserOptionss = {
  config?: MutationConfig<typeof updateState>;
};

export const useUpdateStateMutation = ({ config }: UseAddUserOptionss = {}) => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    onSuccess: () => {
      // showNotification({
      //   type: 'success',
      //   title: 'State updated successfully',
      // });
    },
    ...config,
    mutationFn: updateState,
  });
};